import React from 'react'
import PropTypes from 'prop-types'

import styles from './headerBlockPrices.module.scss'

const HeaderBlockPrices = ({ currency, oldPrice, newPrice }) => {
  return (
    <div className={styles.priceBlock}>
      <div className={styles.priceBlock__label}>from only</div>
      <div className={styles.priceBlock__prices}>
        <span className={styles.priceBlock__oldPrice}>
          {currency}
          {oldPrice}
        </span>
        <div className={styles.priceBlock__newPrice}>
          <div className={styles.priceBlock__currency}>{currency}</div>
          <div>{newPrice}</div>
          <div className={styles.priceBlock__asterix}>*</div>
          <div className={styles.priceBlock__description}>
            <span>
              round-trip,
              <br /> total
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

HeaderBlockPrices.propTypes = {
  currency: PropTypes.string,
  oldPrice: PropTypes.string,
  newPrice: PropTypes.string,
}

export { HeaderBlockPrices }
